export default __webpack_public_path__ + "static/media/coverpage-02.f33b0154.jpg";